/* eslint-disable arrow-body-style */
import axios from "axios";

import { ROUTES_LEGACY_WEBAPP } from "@/modules/payfac/constants/routes";

import { getLocalStorage } from "@shared/constants";

import { BFF_BASE_URL, N8N_BASE_URL, API_BASE_URL } from "./api.constants";

import type { BaseInstanteProps } from "./api.type";

export const baseInstance = ({
  enableXTokenApi = true,
  enableBearerToken = true,
  baseURL = "",
}: BaseInstanteProps) => {
  const instance = axios.create({
    baseURL,
  });

  instance.interceptors.request.use((config) => {
    const token = getLocalStorage("userApiToken");
    const bearerToken = getLocalStorage("userBearerToken");

    if (enableXTokenApi && token) {
      config.headers["X-Token-Api"] = token;
    }

    if (enableBearerToken && bearerToken) {
      config.headers["Authorization"] = `Bearer ${bearerToken}`;
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const { status } = error.response || {};

      if ([401, 403].includes(status)) {
        console.error("Unauthorized access. Implement logout / redirect.");

        if (window?.location?.href) {
          window.location.href = ROUTES_LEGACY_WEBAPP.LOGOUT.fullPath;
        }
      }

      return Promise.reject(error);
    },
  );

  return instance;
};

export const bffInstance = ({
  enableXTokenApi = false,
  enableBearerToken = true,
  baseURL = BFF_BASE_URL,
}: BaseInstanteProps) =>
  baseInstance({ enableXTokenApi, enableBearerToken, baseURL });

export const n8nInstance = ({
  enableXTokenApi = true,
  enableBearerToken = true,
  baseURL = N8N_BASE_URL,
}: BaseInstanteProps) =>
  baseInstance({ enableXTokenApi, enableBearerToken, baseURL });

export const apiInstance = ({
  enableXTokenApi = false,
  enableBearerToken = true,
  baseURL = API_BASE_URL,
}: BaseInstanteProps) =>
  baseInstance({ enableXTokenApi, enableBearerToken, baseURL });
